import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { INVENTORY_TRADING_DAY_BASE_PATH } from '../../../../../../../../../features/inventory/trading-day/inventory-trading-day-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/inventory/trading-day/_trading-day')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'inventory-trading-days',
        label: 'Inventory',
        to: INVENTORY_TRADING_DAY_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
